<div class="impersonation-banner" 
     [class.nav-collapsed]="isNavCollapsed"
     *ngIf="isImpersonating$ | async" 
     role="alert" 
     aria-live="polite">
  <div class="banner-content">
    <div class="status-section">
      <i class="fas fa-user-secret impersonation-icon" aria-hidden="true"></i>
      <div class="status-text">
        <div class="user-info-line">
          <span class="original-user-label">You ({{ (originalUser$ | async)?.Name || 'Unknown' }}) are impersonating:</span>
        </div>
        <div class="target-info-line">
          <span class="target-user-name">{{ (targetUser$ | async)?.Name || 'Unknown User' }}</span>
          <span class="session-info" *ngIf="sessionInfo$ | async as session">
            ({{ session.targetUserRole }} | Started: {{ session.startTime | date:'short' }})
          </span>
        </div>
      </div>
    </div>

    <div class="timer-section" *ngIf="timeRemaining$ | async as timeRemaining">
      <i class="fas fa-clock timer-icon" aria-hidden="true"></i>
      <span class="timer-text">{{ formatTimeRemaining(timeRemaining) }}</span>
      <div class="timer-bar">
        <div class="timer-progress" 
             [style.width.%]="getProgressPercentage(timeRemaining)"></div>
      </div>
    </div>

    <div class="controls-section">
      <button type="button" 
              class="btn-extend"
              (click)="extendSession()"
              [disabled]="isExtending"
              title="Extend impersonation session">
        <i class="fas fa-clock" aria-hidden="true"></i>
        {{ isExtending ? 'Extending...' : 'Extend' }}
      </button>
      
      <button type="button" 
              class="btn-end"
              (click)="endImpersonation()"
              [disabled]="isEnding"
              title="End impersonation session">
        <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        {{ isEnding ? 'Ending...' : 'End Session' }}
      </button>
    </div>
  </div>

  <div class="banner-warning" *ngIf="isSessionExpiringSoon$ | async">
    <i class="fas fa-exclamation-triangle warning-icon" aria-hidden="true"></i>
    <span>Session expires in less than 5 minutes</span>
  </div>
</div>